import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { PaymentIcon } from "react-svg-credit-card-payment-icons";
import { formatFechaMexico } from "../../../utils/format";
import "../withdrawal.css";

interface WithdrawInfoModalProps {
  open: boolean;
  onClose: () => void;
  data?: any;
}

export const WithdrawInfoModal: React.FC<WithdrawInfoModalProps> = ({
  open,
  onClose,
  data,
}) => {
  if (!data) return null;

  const translations: { [key: string]: string } = {
    approved_withdrawal: "Aprobado",
    DECLINED: "Rechazado",
    PENDING: "Pendiente",
    FAILED: "Rechazado",
    awaiting_withdrawal: "Pendiente",
    APPROVED: "Aprobado",
    LIQUIDADO: "Liquidado",
  };

  const translateStatus = (status: string): string => {
    return translations[status] || status;
  };

  const transactions = data?.transactions_id || [];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Información de Dispersión</DialogTitle>
      <DialogContent dividers>
        <p><strong>ID:</strong> {data._id}</p>
        <p><strong>Email:</strong> {data.email}</p>
        <p><strong>Folio:</strong> {data?.folio}</p>
        <p><strong>Id STP:</strong> {data?.stp_id}</p>
        <p><strong>Liquidación:</strong> {data?.tsLiquidacion}</p>
        <p>
          <strong>Monto:</strong>{" "}
          {data?.amount !== undefined && data?.amount !== null
            ? `$${Number(data.amount).toFixed(2)}`
            : "No disponible"}
        </p>
        <p><strong>Estatus:</strong> {data.status}</p>
        <p>
          <strong>Fecha de solicitud:</strong>{" "}
          {formatFechaMexico(data.created_at)}
        </p>

        <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
          Transacciones
        </h3>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell>Banco</TableCell>
                <TableCell>Respuesta de banco</TableCell>
                <TableCell>Correo</TableCell>
                                <TableCell>Costo</TableCell>

                <TableCell>Fecha</TableCell>
                <TableCell>Estado</TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions.length > 0 ? (
                transactions.map((transaction: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell>{transaction.full_name || "N/A"}</TableCell>
                    <TableCell>
                      {transaction.card_brand ? (
                        <PaymentIcon
                          type={transaction.card_brand}
                          format="flatRounded"
                          width={36}
                        />
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                    <TableCell>
                      {transaction.status_description || "N/A"}
                    </TableCell>
                    <TableCell>{transaction.email || "N/A"}</TableCell>
                                        <TableCell>{transaction.amount || "N/A"}</TableCell>

                    <TableCell>
                      {transaction.created_at
                        ? new Date(transaction.created_at).toLocaleDateString(
                            "es-MX",
                            {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              second: "numeric",
                              timeZone: "America/Mexico_City",
                            }
                          )
                        : "N/A"}
                    </TableCell>
                    <TableCell>
                      <div
                        className={`status ${transaction.status.toLowerCase()}`}
                      >
                        {translateStatus(transaction.status || "N/A")}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No hay transacciones disponibles
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};